var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-tabs"},_vm._l((_vm.tabs),function(tab,index){return _c('div',{key:tab.id,staticClass:"my-tabs-content",class:{ 'is-active': _vm.isActive(tab) },on:{"click":function($event){return _vm.handleTabClick(tab, index)}}},[_c('div',{staticClass:"content-info"},[_c('span',[_vm._v(_vm._s(tab.name))])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }